import React, { useState, useEffect } from "react"; 
import "./VehicleLoanForm.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { fetchCustomers } from "../redux/slices/Customer/customerReportSlice";
import { toast } from "react-toastify";

export default function VehicleLoanForm() {
  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

//  console.log("profile data is ",profile);
 
  
  // ---------------- Static Data ----------------
  const [services,setServices]=useState([]);

  
  const [groups,setGroups]=useState([]);
  const [centers,setCenters]=useState([]);

  // const landmarks = ["Near Bank Branch", "Community Center", "Local Shop", "Other"];

  const landmarks = centers
  .map(center => center.address);

  const groupnames= groups 
  .map(group => group.groupname)



  // ---------------- State ----------------
  const [loanType, setLoanType] = useState("");
  const [loanScheme, setLoanScheme] = useState("");
  const [availableSchemes, setAvailableSchemes] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [selectedCustomer,setSelectedCustomer]= useState(null);
  const [selectedGroupLeader,setSelectedGroupLeader]=useState(null);
  const [isFixedLoan, setIsFixedLoan] = useState(false);
  const [loanAmount, setLoanAmount] = useState("");
  const [ltvPercent,setltvPercent]=useState("");
  const [goldmarketvalue,setGoldMarketValue]=useState("");
  const [loanTenure, setLoanTenure] = useState("");
  const [loanEMIAmount, setLoanEMIAmount] = useState("");
  const [loanInterest, setLoanInterest] = useState("");
  const [loanPayable, setLoanPayable] = useState("");
  const [formData, setFormData] = useState({
    loanAmount: "",
    loanTenure: "",
    netGoldWeight:"",
    ltvPercent:"",
    loanPurpose:"",
  });
  const [customers,setCustomers]=useState([])
  const [loanacnumber,setloanacnumber]=useState("GL-10001");
  const [submitStatus, setSubmitStatus] = useState("");
  const [loadingg, setLoading] = useState(false);
  const [marketRate,setMarketRate]= useState(5500);
  // const [loanScheme,setLoanScheme]=useState(null);
  
  

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const branchId = localStorage.getItem("userId");

        const params = new URLSearchParams({
          branchId,
          superAdminId: profile.superAdminId,
          // page: 1,
          limit: 50,
        });

        const res = await axios.get(
          `https://payyug.in/api/customers?${params.toString()}`,
        );

        // console.log("costomers",res)
        setCustomers(res.data?.data || []);
      } catch (error) {
        toast.error("Failed to fetch customers");
      }
    };

    if (profile?.superAdminId) {
      fetchCustomers();
    }
  }, [profile?.superAdminId]);


  const fetchServices = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api//gold-loan/scheme/list?superAdminId=${profile?.superAdminId}`
      );

      // console.log("services data", res);
      setServices(res?.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };


 const fetchMarketRate = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api/fetchgoldrate`
      );
      setMarketRate(res?.data);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };
  
  const fetchCenters = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api/group/centre?LoanofficerId=${profile.id}&branchId=${profile?.branchId}&limit=10000`
      );

       console.log("center data", res);
      setCenters(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const fetchGroups = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api//groupupdate/getall?LoanofficerId=${profile.id}&CenterId=${selectedCenter.id}&limit=10000`
      );

       console.log("groups data", res);
      setGroups(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };


  useEffect(() => {
    fetchServices();
  }, [profile]);

  // useEffect(()=>{
  //   if(profile?.id)
  //   {
  //     fetchCenters();
  //   }
  // },[profile]);

  // useEffect(()=>{
  //   if(selectedCenter?.id)
  //   {
  //     fetchGroups();
  //   }
  // },[selectedCenter]);
  

  // ---------------- Effects ----------------
  useEffect(() => {
    if (loanType) {
      const schemes = services.filter(s => s.serviceType === loanType);
      setAvailableSchemes(schemes);
    } else {
      setAvailableSchemes([]);
      setLoanScheme("");
      setSelectedService(null);
    }
  }, [loanType]);

  useEffect(() => {
    if (loanScheme) {
      const service = services.find(s => s.schemeName === loanScheme);
      setSelectedService(service);
      setIsFixedLoan(service?.fixedLoanAmount > 0);
      fetchMarketRate();
    }
  }, [loanScheme]);

  useEffect(()=>{
   const val=Number(formData.netGoldWeight)*marketRate;
   setGoldMarketValue(val);
  },[formData.netGoldWeight,marketRate])

 
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !selectedCustomer ||
      !selectedService
    ) {
      toast.warn("Please fill all required fields");
      return;
    }

    const payload = {
      superAdminId: profile.superAdminId,
      // branchId: profile.branchId,
      // centerId: selectedCenter.id,
      // centerName: selectedCenter.centerName || "",
      // groupId: selectedGroup.id,
      // groupName: selectedGroup.groupname,
      schemeId: selectedService.id,
      customerId: selectedCustomer.id,
      // memberName: selectedCustomer.fullName,
      // officerId: profile.id,
      // officerName: profile.fullName,
      // groupLeaderId: selectedGroupLeader.id,
      // groupLeaderName: selectedGroupLeader.fullName,
      employeId: profile.id,
      loanAccountNumber: loanacnumber,
      loanAmount: Number(formData.loanAmount),
      loanTenure: Number(formData.loanTenure),
      loanRoi: selectedService.roiPercent,
      emiType:"Flat",
      branchId:profile.branchId,
      loanPurpose: formData.loanPurpose,
      // loanRoiType: selectedService.roiType,
      // loanRecoveryFrequency: selectedService.recoveryFrequency,
      // createdBy: profile.id,
      // loanDisbursalMode:formData.loanDisbursalMode,
      firstEmiDate: new Date(formData.loanAppliedDate),
      netWeight: Number(formData.netGoldWeight),
      marketRate,
      goldValue: goldmarketvalue,
      eligibleLoanAmount: goldmarketvalue,
      ltvPercent: Number(formData.ltvPercent),
      totalCharges: Number(500),
    };

    try {
      setSubmitStatus("loading");
      await axios.post(
        `https://payyug.in/api/gold-loan/create`,
        payload
      );
      toast.success("Group loan applied successfully");
      resetForm();
    } catch (err) {
      toast.error(err?.response?.data?.error || "Submission failed");
    } finally {
      setSubmitStatus("");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // console.log(formData)
  };

  const handleUserIdChange = (e) => {
  const userId = e.target.value;

  // Only fill if typed ID matches
  if (userId === staticUser.id) {
    setFormData(prev => ({
      ...prev,
      userId,
      ...staticUser,
      ...staticGuarantor,
    }));
  } else {
    // Clear the form if ID does not match
    setFormData({ userId });
  }


    // ---------- Static User Data ----------
    const staticUser = {
       id: "U123", 
      fullName: "John Doe",
      mobileNumber: "9876543210",
      aadhaarNumber: "123412341234",
      panNumber: "ABCDE1234F",
      bankAccountNumber: "123456789012",
      ifsc: "IFSC0001",
      guardianName: "Jane Doe",
      address: "123 Main Street",
    };

    // ---------- Static Guarantor Data ----------
    const staticGuarantor = {
      guarantorName: "Mark Smith",
      guarantorMobile: "9123456780",
      guarantorAadhaar: "432143214321",
      guarantorPAN: "XYZAB1234C",
      guarantorRelation: "Friend",
    };

    setFormData(prev => ({
      ...prev,
      userId,
      ...staticUser,
      ...staticGuarantor,
    }));
  };

  const handleNonZeroInput = (value, setter) => {
    const num = Number(value);
    setter(num < 0 ? 0 : num);
  };



  useEffect(() => {
    const isFixed = loanType.toLowerCase().includes("fixed");
    // console.log(selectedService?.rateOfInterest);
    if (!isFixed && Number(loanAmount) > 0 && Number(loanTenure) > 0 && selectedService?.rateOfInterest) {
      const principal = Number(loanAmount);
      const tenure = Number(loanTenure);
      const rateOfInterest = Number(selectedService.roiPercent); // Interest Rate %
      const roiType = selectedService.roiType?.toLowerCase() || "flat"; // flat / reducing
      const recoveryFrequency = selectedService?.recoveryFrequency?.toLowerCase() || "daily"; // EMI frequency
      const roiFrequency = selectedService?.roiFrequency?.toLowerCase() || "monthly"; // ROI frequency
  
      // Mapping for frequency → periods per year
      const periodsPerYearMap = {
        daily: 365,
        weekly: 52,
        "bi-weekly": 26,
        "half-quarterly": 8,
        quarterly: 4,
        monthly: 12,
        yearly: 1,
      };
      const periodsPerYear = periodsPerYearMap[recoveryFrequency] || 12;
  
      // ✅ Calculate periodic rate (match EMI calculator logic)
      let periodRate = 0;
      if (roiFrequency === "yearly") {
        periodRate = rateOfInterest / 100 / periodsPerYear;
      } else if (roiFrequency === "monthly") {
        switch (recoveryFrequency) {
          case "daily":
            // ✅ Simple division (same as your EMI calculator)
            periodRate = rateOfInterest / 100 / 30;
            break;
          case "weekly":
            periodRate = rateOfInterest / 100 / 4;
            break;
          case "bi-weekly":
            periodRate = rateOfInterest / 100 / 2;
            break;
          case "half-quarterly":
            periodRate = rateOfInterest / 100 / 2;
            break;
          case "quarterly":
            periodRate = (rateOfInterest / 100) * 3 / 12;
            break;
          case "monthly":
            periodRate = rateOfInterest / 100;
            break;
          case "yearly":
            periodRate = (rateOfInterest / 100) * 12;
            break;
          default:
            periodRate = rateOfInterest / 100;
        }
      }
  
      let emi = 0;
      let totalInterest = 0;
      let totalPayable = 0;
  
      // === FLAT TYPE ===
      if (roiType === "flat") {
        totalInterest = principal * periodRate * tenure;
        totalPayable = principal + totalInterest;
        emi = totalPayable / tenure;
      }
  
      // === REDUCING TYPE ===
      else if (roiType === "reducing") {
        emi =
          (principal * periodRate * Math.pow(1 + periodRate, tenure)) /
          (Math.pow(1 + periodRate, tenure) - 1);
        totalPayable = emi * tenure;
        totalInterest = totalPayable - principal;
      }
    //  console.log("see this ->",emi,totalInterest,totalPayable);
      // ✅ Update values
      setLoanEMIAmount(Number(emi.toFixed(2)));
      setLoanInterest(Number(totalInterest.toFixed(2)));
      setLoanPayable(Number(totalPayable.toFixed(2)));
  
      // === Optional: Generate EMI Schedule for debug/display ===
      const schedule = [];
      let balance = principal;
      let currentDate = new Date();
  
      for (let i = 1; i <= tenure; i++) {
        const interestComponent = balance * periodRate;
        const principalComponent = emi - interestComponent;
        balance -= principalComponent;
  
        schedule.push({
          emiNo: i,
          emi: Number(emi.toFixed(2)),
          principal: Number(principalComponent.toFixed(2)),
          interest: Number(interestComponent.toFixed(2)),
          balance: balance > 0 ? Number(balance.toFixed(2)) : 0,
          dueDate: new Date(currentDate).toISOString().split("T")[0],
        });
  
        // Increment based on frequency
        switch (recoveryFrequency) {
          case "daily":
            currentDate.setDate(currentDate.getDate() + 1);
            break;
          case "weekly":
            currentDate.setDate(currentDate.getDate() + 7);
            break;
          case "bi-weekly":
            currentDate.setDate(currentDate.getDate() + 14);
            break;
          case "monthly":
            currentDate.setMonth(currentDate.getMonth() + 1);
            break;
          default:
            currentDate.setDate(currentDate.getDate() + 1);
        }
      }
    
      // console.table(schedule); // Optional: view full EMI breakdown in console
  
    } 
    else {
      setLoanEMIAmount(0);
      setLoanInterest(0);
      setLoanPayable(0);
    }
  }, [loanAmount, loanTenure, selectedService, loanType]);

  useEffect(()=>{
     const totalGoldValue=formData.netGoldWeight*marketRate;

  },[formData.netGoldWeight,marketRate])

  const resetForm = () => {
    setLoanType("");
  setAvailableSchemes([]);
    setLoanScheme("");
    setSelectedService(null);
    setSelectedCenter(null);
    setSelectedGroup(null);
    setSelectedCustomer(null);
    setSelectedGroupLeader(null);
    setFormData({
      loanAmount: "",
      loanTenure: "",
      loanAppliedDate: "",
      loanDisbursalMode: "",
      groupLeaderRelation: "",
      netGoldWeight:"",
      ltvPercent:"",
      loanPurpose:"",
    });
    setLoanEMIAmount(0);
    setLoanInterest(0);
    setLoanPayable(0);
  };
//   console.log("selected service ",selectedService);
  
  // ---------------- Render ----------------
//  return (
//   <div className="gold-loan-form-container">
//     <h1>Gold Loan Application Form</h1>

//     <form
//       id="gold-loan-form"
//       className="gold-loan-form-section"
//       onSubmit={handleSubmit}
//       noValidate
//     >

//       {/* Loan Options */}
//       <section className="gold-loan-form-inputs-section">
//         <h2>Gold Loan Options & Schemes</h2>

//         <div className="gold-loan-form-loan-options">

//           <div className="gold-loan-form-input-groups">
//             <label htmlFor="loan-type">Gold Loan Type</label>
//             <select
//               id="loan-type"
//               value={loanType}
//               onChange={(e) => setLoanType(e.target.value)}
//               required
//             >
//               <option value="" disabled>Select Gold Loan Type</option>
//               {[...new Set(services.map((s) => s.serviceType))].map(
//                 (type) => <option key={type} value={type}>{type}</option>
//               )}
//             </select>
//           </div>

//           <div className="gold-loan-form-input-groups">
//             <label htmlFor="loan-scheme">Gold Loan Scheme</label>
//             <select
//               id="loan-scheme"
//               value={loanScheme}
//               onChange={(e) => setLoanScheme(e.target.value)}
//               disabled={!availableSchemes.length}
//               required
//             >
//               <option value="" disabled>Select Scheme</option>
//               {availableSchemes.map((s) =>
//                 <option key={s.serviceName} value={s.serviceName}>
//                   {s.serviceName}
//                 </option>
//               )}
//             </select>
//           </div>

//         </div>
//       </section>


//       {/* Loan Details */}
//       <section className="gold-loan-form-inputs-section">
//         <h2>Gold Loan Details</h2>

//         <div className="gold-loan-form-details-grid">

//           <div className="gold-loan-form-input-groups">
//             <label>Minimum Loan Amount</label>
//             <input
//               type="number"
//               value={selectedService?.minAmount ?? ""}
//               readOnly
//             />
//           </div>

//           <div className="gold-loan-form-input-groups">
//             <label>Maximum Loan Amount</label>
//             <input
//               type="number"
//               value={selectedService?.maxAmount ?? ""}
//               readOnly
//             />
//           </div>

//           <div className="gold-loan-form-input-groups">
//             <label>Gold Loan Interest Rate (%)</label>
//             <input
//               type="number"
//               value={selectedService?.rateOfInterest || ""}
//               readOnly
//             />
//           </div>

//           <div className="gold-loan-form-input-groups">
//             <label>ROI Type</label>
//             <input
//               type="text"
//               value={selectedService?.roiType || ""}
//               readOnly
//             />
//           </div>

//           <div className="gold-loan-form-input-groups">
//             <label>Recovery Frequency</label>
//             <input
//               type="text"
//               value={selectedService?.recoveryType || ""}
//               readOnly
//             />
//           </div>

//           {/* Loan Amount */}
//           <div className="gold-loan-form-input-groups">
//             <label>Loan Amount</label>
//             <input
//               type="number"
//               name="loanAmount"
//               value={formData.loanAmount}
//               onChange={(e) => {
//                 handleNonZeroInput(e.target.value, setLoanAmount);
//                 handleChange(e);
//               }}
//               required
//             />
//           </div>

//           {/* Loan Tenure */}
//           <div className="gold-loan-form-input-groups">
//             <label>Loan Tenure</label>
//             <input
//               type="number"
//               name="loanTenure"
//               value={formData.loanTenure}
//               onChange={(e) => {
//                 handleNonZeroInput(e.target.value, setLoanTenure);
//                 handleChange(e);
//               }}
//               required
//             />
//           </div>

//           {/* EMI Details */}
//           <div className="gold-loan-form-input-groups">
//             <label>Loan EMI Amount</label>
//             <input type="number" value={loanEMIAmount} readOnly />
//           </div>

//           <div className="gold-loan-form-input-groups">
//             <label>Total Interest</label>
//             <input type="number" value={loanInterest} readOnly />
//           </div>

//           <div className="gold-loan-form-input-groups">
//             <label>Total Payable Amount</label>
//             <input type="number" value={loanPayable} readOnly />
//           </div>

//         </div>
//       </section>


//       {/* Customer Details */}
//       <section className="gold-loan-form-inputs-section">
//         <h2>Customer Details</h2>

//         <div className="gold-loan-form-input-groups">
//           <label>Select Customer</label>
//           <select
//             onChange={(e) => {
//               const customer = customers.find(
//                 (c) => c.id === Number(e.target.value)
//               );
//               setSelectedCustomer(customer);
//             }}
//           >
//             <option value="">Select Customer</option>
//             {customers.map((c) =>
//               <option key={c.id} value={c.id}>
//                 {c.fullName} ({c.userId})
//               </option>
//             )}
//           </select>
//         </div>

//         {selectedCustomer && (
//           <div className="gold-loan-form-details-grid">

//             <div className="gold-loan-form-input-groups">
//               <label>Mobile Number</label>
//               <input value={selectedCustomer.mobileNumber} readOnly />
//             </div>

//             <div className="gold-loan-form-input-groups">
//               <label>Aadhaar Number</label>
//               <input value={selectedCustomer.aadhaarNumber} readOnly />
//             </div>

//             <div className="gold-loan-form-input-groups">
//               <label>PAN Number</label>
//               <input value={selectedCustomer.panNumber} readOnly />
//             </div>

//             <div className="gold-loan-form-input-groups">
//               <label>Address</label>
//               <input value={selectedCustomer.address} readOnly />
//             </div>

//           </div>
//         )}
//       </section>


//       {/* Nominee Details */}
//       <section className="gold-loan-form-inputs-section">
//         <h2>Nominee Details</h2>

//         <div className="gold-loan-form-details-grid">

//           <div className="gold-loan-form-input-groups">
//             <label>Nominee Name</label>
//             <input
//               type="text"
//               name="nomineeName"
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="gold-loan-form-input-groups">
//             <label>Relation with Applicant</label>
//             <input
//               type="text"
//               name="nomineeRelation"
//               onChange={handleChange}
//               required
//             />
//           </div>

//         </div>
//       </section>


//       <div className="gold-loan-form-submit-wrapper">
//         <button
//           type="submit"
//           className="gold-loan-form-submit-btn"
//         >
//           Apply Gold Loan
//         </button>
//       </div>

//     </form>
//   </div>
// );

return (
  <div className="vehicle-loan-form-container">
    <h1>Vehicle Loan Application Form</h1>

    {loadingg && <p>Loading available vehicle loan schemes...</p>}

    <form
      id="vehicle-loan-form"
      className="vehicle-loan-form-section"
      onSubmit={handleSubmit}
      noValidate
    >

      {/* Vehicle Loan Options & Schemes */}
      <section className="vehicle-loan-form-inputs-section">
        <h2>Vehicle Loan Options & Schemes</h2>

        <div className="vehicle-loan-form-loan-options">

          <div className="vehicle-loan-form-input-groups">
            <label htmlFor="loan-type">Vehicle Loan Type</label>
            <select
              id="loan-type"
              value={loanType}
              onChange={(e) => setLoanType(e.target.value)}
              required
            >
              <option value="" disabled>Select Vehicle Loan Type</option>
              {[...new Set(services.map((s) => s.serviceType))].map(
                (type) => <option key={type} value={type}>{type}</option>
              )}
            </select>
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label htmlFor="loan-scheme">Vehicle Loan Scheme</label>
            <select
              id="loan-scheme"
              value={loanScheme}
              onChange={(e) => setLoanScheme(e.target.value)}
              disabled={!availableSchemes.length}
              required
            >
              <option value="" disabled>Select Scheme</option>
              {availableSchemes.map((s) =>
                <option key={s.schemeName} value={s.schemeName}>
                  {s.schemeName}
                </option>
              )}
            </select>
          </div>

        </div>
      </section>

      {/* Vehicle Loan Details */}
      <section className="vehicle-loan-form-inputs-section">
        <h2>Vehicle Loan Details</h2>

        <div className="vehicle-loan-form-details-grid">

          <div className="vehicle-loan-form-input-groups">
            <label>Minimum Loan Amount</label>
            <input type="number" value={selectedService?.minLoanAmount ?? ""} readOnly />
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label>Maximum Loan Amount</label>
            <input type="number" value={selectedService?.maxLoanAmount ?? ""} readOnly />
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label>Minimum Vehicle Value</label>
            <input type="number" value={selectedService?.minNetWeight ?? ""} readOnly />
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label>Maximum Vehicle Value</label>
            <input type="number" value={selectedService?.maxNetWeight ?? ""} readOnly />
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label>Vehicle Loan Interest Rate (%)</label>
            <input type="number" value={selectedService?.roiPercent || ""} readOnly />
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label>Interest Calculation Method</label>
            <input type="text" value={selectedService?.interestCalculationMethod || ""} readOnly />
          </div>

          {["roiType", "recoveryFrequency", "tenureType", "maxTenure"].map((id) => (
            <div className="vehicle-loan-form-input-groups" key={id}>
              <label>
                {{
                  roiType: "Interest Type",
                  recoveryFrequency: "Recovery Frequency",
                  tenureType: "Is Fixed Tenure",
                  maxTenure: `Maximum Tenure (${selectedService?.tenureType || ""})`,
                }[id]}
              </label>
              <input
                type="text"
                value={
                  id === "tenureType"
                    ? selectedService?.[id] ? "Yes" : "No"
                    : selectedService?.[id] ?? ""
                }
                readOnly
              />
            </div>
          ))}

          {[
            { id: "netGoldWeight", label: "Vehicle Value" },
            { id: "ltvPercent", label: "Financing Percentage (%)" },
            { id: "goldmarketvalue", label: "Vehicle Market Value" },
            { id: "loanAmount", label: "Loan Amount" },
            { id: "loanTenure", label: "Loan Tenure" },
          ].map(({ id, label }) => (
            <div className="vehicle-loan-form-input-groups" key={id}>
              <label htmlFor={id}>{label}</label>
              <input
                type="number"
                id={id}
                name={id}
                value={id === "goldmarketvalue" ? goldmarketvalue : formData[id] || ""}
                readOnly={id === "goldmarketvalue"}
                onChange={(e) => {
                  handleNonZeroInput(
                    e.target.value,
                    id === "loanAmount" ? setLoanAmount : setLoanTenure
                  );
                  handleChange(e);
                }}
              />
            </div>
          ))}

          <div className="vehicle-loan-form-input-groups">
            <label>Vehicle Market Rate</label>
            <input type="number" value={marketRate ?? ""} readOnly />
          </div>

          {[
            { id: "loanEMIAmount", label: "Loan EMI Amount", value: loanEMIAmount },
            { id: "loanInterest", label: "Total Interest Amount", value: loanInterest },
            { id: "loanPayable", label: "Total Payable Amount", value: loanPayable },
          ].map(({ id, label, value }) => (
            <div className="vehicle-loan-form-input-groups" key={id}>
              <label>{label}</label>
              <input type="number" value={value} readOnly />
            </div>
          ))}

          <div className="vehicle-loan-form-input-groups">
            <label>Loan Disbursal Mode</label>
            <select
              name="loanDisbursalMode"
              value={formData.loanDisbursalMode || ""}
              onChange={handleChange}
            >
              <option value="" disabled>Select Mode</option>
              <option value="Bank Transfer">Bank Transfer</option>
              <option value="Cheque">Cheque</option>
              <option value="Cash">Cash</option>
            </select>
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label>Vehicle Loan Purpose</label>
            <input
              type="text"
              name="loanPurpose"
              value={formData.loanPurpose || ""}
              onChange={handleChange}
            />
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label>Vehicle Loan Applied Date</label>
            <input
              type="date"
              name="loanAppliedDate"
              value={formData.loanAppliedDate || ""}
              onChange={handleChange}
            />
          </div>

        </div>
      </section>

      {/* Customer Details */}
      <section className="vehicle-loan-form-inputs-section">
        <h2>Customer Details</h2>

        <div className="vehicle-loan-form-input-groups">
          <label>Customer Name & ID</label>
          <select
            onChange={(e) => {
              const customer = customers.find(
                (c) => c.id === Number(e.target.value)
              );
              setSelectedCustomer(customer);
            }}
          >
            <option value="">Select Customer</option>
            {customers.map((c) =>
              <option key={c.id} value={c.id}>
                {c.fullName} ({c.userId})
              </option>
            )}
          </select>
        </div>

        {selectedCustomer && (
          <div className="vehicle-loan-form-details-grid">
            <div className="vehicle-loan-form-input-groups">
              <label>Mobile Number</label>
              <input value={selectedCustomer.mobileNumber} readOnly />
            </div>

            <div className="vehicle-loan-form-input-groups">
              <label>Aadhaar Number</label>
              <input value={selectedCustomer.aadhaarNumber} readOnly />
            </div>

            <div className="vehicle-loan-form-input-groups">
              <label>PAN Number</label>
              <input value={selectedCustomer.panNumber} readOnly />
            </div>

            <div className="vehicle-loan-form-input-groups">
              <label>Address</label>
              <input value={selectedCustomer.address} readOnly />
            </div>
          </div>
        )}
      </section>

      {/* Nominee Details */}
      <section className="vehicle-loan-form-inputs-section">
        <h2>Nominee Details</h2>

        <div className="vehicle-loan-form-details-grid">

          <div className="vehicle-loan-form-input-groups">
            <label>Nominee Name</label>
            <select
              onChange={(e) => {
                const customer = customers.find(
                  (c) => c.id === Number(e.target.value)
                );
                setSelectedGroupLeader(customer);
              }}
            >
              <option value="">Select Nominee</option>
              {customers.map((c) =>
                <option key={c.id} value={c.id}>{c.fullName}</option>
              )}
            </select>
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label>Mobile Number</label>
            <input value={selectedGroupLeader?.mobileNumber || ""} readOnly />
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label>Aadhaar Number</label>
            <input value={selectedGroupLeader?.aadhaarNumber || ""} readOnly />
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label>PAN Number</label>
            <input value={selectedGroupLeader?.panNumber || ""} readOnly />
          </div>

          <div className="vehicle-loan-form-input-groups">
            <label>Relation with Applicant</label>
            <input
              type="text"
              name="groupLeaderRelation"
              value={formData.groupLeaderRelation || ""}
              onChange={handleChange}
            />
          </div>

        </div>
      </section>

      <div className="vehicle-loan-form-submit-wrapper">
        <button
          type="submit"
          className="vehicle-loan-form-submit-btn"
          disabled={submitStatus === "loading"}
        >
          {submitStatus === "loading"
            ? "Submitting..."
            : "Apply Vehicle Loan"}
        </button>
      </div>

    </form>
  </div>
);


}

